import { match, matchPath } from 'react-router'
import { createSelector } from 'reselect'
import { BankAccountListModel } from 'src/models/bankAccount.models'
import { OrganizationIntegrationListModel } from 'src/models/organizationIntegration.models'
import { TaxRateListResponse } from 'src/models/taxRate.models'
import {
  ManageOrgIntegrationMatchParams,
  manageOrgIntegrationRouteProps,
} from 'src/navigation/routeProps'
import { RootState } from 'src/redux/createRootReducer'
import { selectLocationFromState } from 'src/redux/selectors/router.selectors'

export const selectBankAccountsFromState = (
  state: RootState,
): BankAccountListModel[] | undefined => {
  return state.app.manageOrgIntegration.bankAccounts?.map(
    (account) => new BankAccountListModel(account),
  )
}

export const selectTaxRatesFromState = (
  state: RootState,
): TaxRateListResponse[] | undefined => {
  const taxRates = state.app.manageOrgIntegration.taxRates
  return taxRates ? Object.values(taxRates) : undefined
}

export const selectIsDeletingNetsuiteOrgIntegration = (
  state: RootState,
): boolean => state.app.manageOrgIntegration.isDeletingOrgIntegration

export const selectIsAddingNetsuiteAccountTransactionSource = (
  state: RootState,
): boolean => state.app.manageOrgIntegration.isAddingOrgIntegrationAccount

export const selectOrgIntegrationModelFromState = (
  state: RootState,
): OrganizationIntegrationListModel | undefined => {
  return state.app.manageOrgIntegration.orgIntegration
    ? new OrganizationIntegrationListModel(
        state.app.manageOrgIntegration.orgIntegration,
      )
    : undefined
}

export const selectIntegrationIdFromRoute = createSelector(
  [selectLocationFromState],
  (location) => {
    const mtch = matchPath<ManageOrgIntegrationMatchParams>(
      location.pathname,
      manageOrgIntegrationRouteProps,
    ) as match<ManageOrgIntegrationMatchParams>
    // TODO CookieValuePathsFeatureFlagging.showOrganizationSettings: remove the if statement after removing ManageOrgs flyout
    if (mtch?.params.integrationId === undefined) {
      const mtch2 = matchPath<ManageOrgIntegrationMatchParams>(
        location.pathname,
        manageOrgIntegrationRouteProps,
      ) as match<ManageOrgIntegrationMatchParams>
      return mtch2?.params.integrationId
    }
    return mtch?.params.integrationId
  },
)

export const selectTopLevelManageOrgIntegrationErrorFromState = (
  state: RootState,
): string | undefined => state.app.manageOrgIntegration.topLevelError

// export const selectErrorDetailMapFromState = (state: RootState): ErrorDetailMap<string> | undefined => (
//   state.app.manageOrgIntegration.errorDetailMap
// )
